import type { ToastActionElement, ToastProps } from "@/components/ui/toast";
import { useTranslation } from "react-i18next";
import { useToast } from "./useToast";

export type ErrorToastProps = {
    titleTranslationKey: string;
    /** Affiché tant que `titleTranslationKey` manque aux fichiers de traduction. */
    titleDefaultValue?: string;
    descriptionTranslationKey?: string;
    variant?: ToastProps["variant"];
    action?: ToastActionElement;
};

const useErrorToast = () => {
    const { toast } = useToast();
    const { t } = useTranslation();

    const showErrorToast = ({
        titleTranslationKey,
        titleDefaultValue,
        descriptionTranslationKey,
        variant = "error",
        action,
    }: ErrorToastProps) => {
        toast({
            title: t(titleTranslationKey, { defaultValue: titleDefaultValue }),
            description: descriptionTranslationKey
                ? t(descriptionTranslationKey)
                : t("errors.global.description"),
            variant,
            action,
        });
    };

    return showErrorToast;
};

export default useErrorToast;
